import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { PrefilledLineEditorForm } from './PrefilledLineEditorForm';

export interface PrefilledLineEditorModalProps {
  open: boolean;
  onClose?: () => void;

  form: PrefilledLineEditorForm.FormState;
}

export const PrefilledLineEditorModal = (
  props: PrefilledLineEditorModalProps,
) => {
  const { form, open, onClose } = props;
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={'md'}>
      <DialogTitle>Editeur de ligne pré-remplie</DialogTitle>
      <DialogContent sx={{ margin: (theme) => theme.spacing(2, 0) }}>
        <DialogContentText>
          Définissez les valeurs qui seront pré-remplies.
        </DialogContentText>
        <PrefilledLineEditorForm.Component form={form} />
      </DialogContent>
      <DialogActions>
        <Button color={'primary'} onClick={onClose}>
          Annuler
        </Button>
        <Button
          color={'primary'}
          variant={'contained'}
          onClick={() => form.handleFormSubmit()}
        >
          Enregistrer
        </Button>
      </DialogActions>
    </Dialog>
  );
};
